<template>
    <div class="bulletinBoard">
        <el-card class="box-card">
            <div class="title">数据概览</div>
            <el-radio-group size="small" v-model="tabType1" style="margin-top: 10px;" @input="changeTabtype">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart1" :style="{ width: '100%', height: '300px' }"></div>
            </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 8px;">
            <div class="title">重复订单</div>
            <el-radio-group size="small" v-model="tabType2" style="margin-top: 10px;" @input="changeTabtype2">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart2" :style="{ width: '100%', height: '300px' }"></div>
            </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 8px;">
            <div class="title">重复金额占比</div>
            <el-radio-group size="small" v-model="tabType3" style="margin-top: 10px;" @input="changeTabtype3">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart3" :style="{ width: '100%', height: '250px' }"></div>
            </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 8px;">
            <div class="title">重复订单占比</div>
            <el-radio-group size="small" v-model="tabType4" style="margin-top: 10px;" @input="changeTabtype4">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart4" :style="{ width: '100%', height: '250px' }"></div>
            </div>
        </el-card>

        <el-card class="box-card" style="margin-top: 8px;">
            <div class="title">联盟客类型分销金额占比</div>
            <el-radio-group size="small" v-model="tabType5" style="margin-top: 10px;" @input="changeTabtype5">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart5" :style="{ width: '100%', height: '250px' }"></div>
            </div>

            <div class="title" style="margin-top: 20px;">联盟客分销金额TOP 5</div>
            <el-table :data="tableData1" style="width: 100%">
                <el-table-column type="index" width="50">
                </el-table-column>
                <el-table-column width="90" prop="website" show-overflow-tooltip label="联盟客姓名"></el-table-column>
                <el-table-column width="90" prop="transamount" show-overflow-tooltip label="分销金额">
                </el-table-column>
                <el-table-column width="90" prop="affiliateid" show-overflow-tooltip label="联盟客ID"></el-table-column>
                <el-table-column width="120" prop="affiliatewebsite" show-overflow-tooltip label="推广网站"></el-table-column>
                <el-table-column width="120" prop="platformtype" show-overflow-tooltip label="联盟客平台">
                </el-table-column>
            </el-table>
        </el-card>

        <el-card class="box-card" style="margin-top: 8px;">
            <div class="title">联盟客类型分销订单数占比</div>
            <el-radio-group size="small" v-model="tabType6" style="margin-top: 10px;" @input="changeTabtype6">
                <el-radio-button label="1">过去7天</el-radio-button>
                <el-radio-button label="2">过去30天</el-radio-button>
                <el-radio-button label="3">过去90天</el-radio-button>
                <el-radio-button label="4">过去一年</el-radio-button>
            </el-radio-group>
            <div class="charts">
                <div id="myChart6" :style="{ width: '100%', height: '250px' }"></div>
            </div>
            <div class="title" style="margin-top: 20px;">联盟客分销订单数TOP 5</div>
            <el-table :data="tableData2" style="width: 100%">
                <el-table-column type="index" width="50">
                </el-table-column>
                <el-table-column width="90" prop="website" show-overflow-tooltip label="联盟客姓名"></el-table-column>
                <el-table-column width="90" prop="transcount" show-overflow-tooltip label="分销订单数">
                </el-table-column>
                <el-table-column width="90" prop="affiliateid" show-overflow-tooltip label="联盟客ID"></el-table-column>
                <el-table-column width="120" prop="affiliatewebsite" show-overflow-tooltip label="推广网站"></el-table-column>
                <el-table-column width="120" prop="platformtype" show-overflow-tooltip label="联盟客平台">
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>
<script>
import { QUERYCLICKSDETAIL, QUERYAMOUNTDATADETAIL, QUERYORDERDATADETAIL, QUERYAMOUNTCOUNTCHART, QUERYREPEATORDERCHART, QUERYTOP5DATA, QUERYAFFLIATETYPERATE, QUERYREPEATRATE, HASPLATFORMLIST } from '@/api/platform'
import util from '@/utils/util'
export default {
    data() {
        return {
            tabType1: '1',
            tabType2: '1',
            tabType3: '1',
            tabType4: '1',
            tabType5: '1',
            tabType6: '1',
            startDate1: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            startDate2: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            startDate3: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            startDate4: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            startDate5: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            startDate6: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
            option1: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '5%',
                    top: '15%',
                    right: '5%',
                    bottom: '25%',
                    containLabel: true
                },
                legend: {
                    bottom: 0,
                    data: ['AvantLink分销金额', 'AvantLink分销订单数', 'ShareASale分销金额', 'ShareASale分销订单数']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['2023/08/02', '2023/08/03', '2023/08/04', '2023/08/05', '2023/08/06', '2023/08/07', '2023/08/08'],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel: {
                            // 旋转角度
                            rotate: 45
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        show: true,
                        position: 'left',
                        name: '订单数',
                        interval: 5000,
                        minInterval: 1,
                        axisLabel: {
                            formatter: '{value} '
                        }
                    },
                    {
                        type: 'value',
                        name: '金额',
                        position: 'right',
                        interval: 5000,
                        axisLabel: {
                            formatter: '{value} '
                        },
                        minInterval: 1,
                    },
                ],
                series: [
                    {
                        name: 'AvantLink分销金额',
                        type: 'bar',
                        yAxisIndex: 1,
                        barWidth: 10,//柱图宽度
                        itemStyle: {    //柱状图的背景色
                            normal: {
                                color: util.color16()
                            }
                        },
                        data: [10, 52, 42, 15, 7, 45, 25]
                    },
                    {
                        name: 'AvantLink分销订单数',
                        type: 'line',
                        symbolSize: 5,
                        color: util.color16(),
                        data: [10, 52, 42, 15, 7, 45, 25]
                    },
                    {
                        name: 'ShareASale分销金额',
                        type: 'bar',
                        yAxisIndex: 1,
                        barWidth: 10,//柱图宽度
                        itemStyle: {    //柱状图的背景色
                            normal: {
                                color: util.color16()
                            }
                        },
                        data: [10, 52, 42, 15, 7, 45, 25]
                    },
                    {
                        name: 'ShareASale分销订单数',
                        type: 'line',
                        symbolSize: 5,
                        color: util.color16(),
                        data: [10, 52, 42, 15, 7, 45, 25]
                    }
                ],
                dataZoom: [
                    {
                        show: false, // 为true 滚动条出现
                        realtime: true,
                        type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
                        height: 10, // 表示滚动条的高度，也就是粗细
                        start: 0, // 表示默认展示20%～80%这一段。
                        end: 100,
                        handleSize: 0,      //两边手柄尺寸
                        dataBackground: {
                            areaStyle: {
                                color: '#fff'
                            }
                        },
                        backgroundColor: '#fff',
                        borderColor: "#ffffff",
                        fillerColor: '#fff',
                        moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
                        moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
                        zoomLock: true,         //是否只平移不缩放
                        showDetail: false, //拖拽时是否展示滚动条两侧的文字
                        zoomOnMouseWheel: true,  // 关闭滚轮缩放
                        moveOnMouseWheel: true, // 开启滚轮平移
                        moveOnMouseMove: true,  // 鼠标移动能触发数据窗口平移 
                        bottom: 10,
                    },
                    {//没有下面这块的话，只能拖动滚动条，鼠标滚轮在区域内不能控制外部滚动条
                        type: 'inside',
                        xAxis: 0,
                        zoomOnMouseWheel: false,  //滚轮是否触发缩放
                        moveOnMouseMove: true,  //鼠标滚轮触发滚动
                        moveOnMouseWheel: true
                    }
                ]
            },
            option2: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '5%',
                    top: '15%',
                    right: '5%',
                    bottom: '10%',
                    containLabel: true
                },
                legend: {
                    bottom: 0,
                    data: ['重复金额', '重复订单'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['2023/08/02', '2023/08/03', '2023/08/04', '2023/08/05', '2023/08/06', '2023/08/07', '2023/08/08'],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel: {
                            // 旋转角度
                            rotate: 45
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        show: true,
                        position: 'left',
                        name: '订单数',
                        interval: 5000,
                        minInterval: 1,
                        axisLabel: {
                            formatter: '{value} '
                        }
                    },
                    {
                        type: 'value',
                        name: '金额',
                        position: 'right',
                        interval: 5000,
                        axisLabel: {
                            formatter: '{value} '
                        },
                        minInterval: 1,
                    },
                ],
                series: [
                ],
                dataZoom: [
                    {
                        show: false, // 为true 滚动条出现
                        realtime: true,
                        type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
                        height: 10, // 表示滚动条的高度，也就是粗细
                        start: 0, // 表示默认展示20%～80%这一段。
                        end: 100,
                        handleSize: 0,      //两边手柄尺寸
                        dataBackground: {
                            areaStyle: {
                                color: '#fff'
                            }
                        },
                        backgroundColor: '#fff',
                        borderColor: "#ffffff",
                        fillerColor: '#fff',
                        moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
                        moveOnMouseMove: true, //鼠标移动能触发数据窗口平移
                        zoomLock: true,         //是否只平移不缩放
                        showDetail: false, //拖拽时是否展示滚动条两侧的文字
                        zoomOnMouseWheel: true,  // 关闭滚轮缩放
                        moveOnMouseWheel: true, // 开启滚轮平移
                        moveOnMouseMove: true,  // 鼠标移动能触发数据窗口平移 
                        bottom: 10,
                    },
                    {//没有下面这块的话，只能拖动滚动条，鼠标滚轮在区域内不能控制外部滚动条
                        type: 'inside',
                        xAxis: 0,
                        zoomOnMouseWheel: false,  //滚轮是否触发缩放
                        moveOnMouseMove: true,  //鼠标滚轮触发滚动
                        moveOnMouseWheel: true
                    }
                ]
            },
            tableData1: [],
            tableData2: [],
        }
    },
    created() {
        this.queryAmountCountChartmap()
        this.queryDoubleReport()
        this.queryRepeatAmountRatemap()
        this.queryRepeatOrderRatemap()
        this.queryAffliateAmountRatemap()
        this.queryAffliateCountRatemap()
        this.queryTop5Amountmap()
        this.queryTop5Countmap()
    },
    mounted() {

    },
    methods: {
        // 数据概览
        queryAmountCountChartmap() {
            QUERYAMOUNTCOUNTCHART({ startDate: this.startDate1 }).then(res => {
                this.option1.xAxis[0].data = res.data.body.xdate
                let arr1 = res.data.body.platforms
                let series = []
                arr1.forEach((item, index) => {
                    let color = util.color16()
                    this.option1.legend.data.push(item.name + '分销金额')
                    this.option1.legend.data.push(item.name + '分销订单数')
                    series.push({
                        name: item.name + '分销金额',
                        type: 'bar',
                        yAxisIndex: 1,
                        barWidth: 5,//柱图宽度
                        itemStyle: {    //柱状图的背景色
                            normal: {
                                color: color
                            }
                        },
                        data: item.amount
                    })
                    series.push({
                        name: item.name + '分销订单数',
                        type: 'line',
                        symbolSize: 5,
                        color: color,
                        data: item.count
                    })
                    this.option1.series = series
                })
                this.$nextTick(() => {
                    this.drawPie1(this.option1)
                })
            })
        },
        // 查询重复订单
        queryDoubleReport() {
            QUERYREPEATORDERCHART({ startDate: this.startDate2 }).then(res => {
                this.option2.xAxis[0].data = res.data.body.xdate
                let color = util.color16()
                this.option2.legend.data = ['重复金额', '重复订单数']
                let series = [
                    {
                        name: '重复金额',
                        type: 'bar',
                        yAxisIndex: 1,
                        barWidth: 5,//柱图宽度
                        itemStyle: {    //柱状图的背景色
                            normal: {
                                color: color
                            }
                        },
                        data: res.data.body.repeatAmounts
                    },
                    {
                        name: '重复订单数',
                        type: 'line',
                        symbolSize: 5,
                        color: color,
                        data: res.data.body.repeatCounts
                    }
                ]
                this.option2.series = series

                this.$nextTick(() => {
                    this.drawPie2(this.option2)
                })
            })
        },
        // 重复金额/订单占比
        queryRepeatAmountRatemap() {
            QUERYREPEATRATE({ startDate: this.startDate3, platformType: 'shareASale' }).then(res => {
                let amountrate = res.data.body.amountrate
                let option = {
                    series: [
                        {
                            type: 'gauge',
                            center: ['50%', '50%'],
                            startAngle: 180,
                            endAngle: 0,
                            min: 0,
                            max: 100,
                            splitNumber: 12,
                            itemStyle: {
                                color: '#7892EC'
                            },
                            progress: {
                                show: true,
                                width: 30
                            },
                            pointer: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    width: 30
                                }
                            },
                            axisTick: {
                                show: false,
                            },
                            splitLine: {
                                show: false,
                            },
                            axisLabel: {
                                show: false,
                            },
                            anchor: {
                                show: true
                            },
                            title: {
                                show: true
                            },
                            detail: {
                                valueAnimation: true,
                                width: '100%',
                                lineHeight: 15,
                                borderRadius: 8,
                                offsetCenter: [0, '-15%'],
                                fontSize: 12,
                                fontWeight: 'bolder',
                                formatter: '百分比\n {value}%',
                                color: '#7892EC'
                            },
                            data: [
                                {
                                    value: amountrate
                                }
                            ],

                        },
                    ]
                };
                this.$nextTick(() => {
                    this.drawPie3(option)
                })
            })
        },
        queryRepeatOrderRatemap() {
            QUERYREPEATRATE({ startDate: this.startDate4, platformType: 'shareASale' }).then(res => {
                let countrate = res.data.body.countrate
                let option = {
                    series: [
                        {
                            type: 'gauge',
                            center: ['50%', '50%'],
                            startAngle: 180,
                            endAngle: 0,
                            min: 0,
                            max: 100,
                            splitNumber: 12,
                            itemStyle: {
                                color: '#7892EC'
                            },
                            progress: {
                                show: true,
                                width: 30
                            },
                            pointer: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    width: 30
                                }
                            },
                            axisTick: {
                                show: false,
                            },
                            splitLine: {
                                show: false,
                            },
                            axisLabel: {
                                show: false,
                            },
                            anchor: {
                                show: true
                            },
                            title: {
                                show: true
                            },
                            detail: {
                                valueAnimation: true,
                                width: '100%',
                                lineHeight: 15,
                                borderRadius: 8,
                                offsetCenter: [0, '-15%'],
                                fontSize: 12,
                                fontWeight: 'bolder',
                                formatter: '百分比\n {value}%',
                                color: '#7892EC'
                            },
                            data: [
                                {
                                    value: countrate
                                }
                            ],

                        },
                    ]
                };
                this.$nextTick(() => {
                    this.drawPie4(option)
                })
            })
        },
        // 联盟客类型分销占比
        queryAffliateAmountRatemap() {
            QUERYAFFLIATETYPERATE({ startDate: this.startDate5, type: 'amount' }).then(res => {
                this.amountRateData = res.data.body
                this.$nextTick(() => {
                    this.drawPie5()
                })
            })
        },
        queryAffliateCountRatemap() {
            QUERYAFFLIATETYPERATE({ startDate: this.startDate6, type: 'count' }).then(res => {
                this.countRateData = res.data.body
                this.$nextTick(() => {
                    this.drawPie6()
                })
            })
        },
        //  top5表格数据
        queryTop5Amountmap() {
            QUERYTOP5DATA({ startDate: this.startDate5, type: 'amount' }).then(res => {
                this.tableData1 = res.data.body
            })
        },
        queryTop5Countmap() {
            QUERYTOP5DATA({ startDate: this.startDate6, type: 'count' }).then(res => {
                this.tableData2 = res.data.body
            })
        },



        drawPie1(option) {
            let myChart = this.$echarts.init(document.getElementById("myChart1"));
            // 增加了一个隐藏的x轴，用来控制线图的点的位置
            option.xAxis[1] = {
                type: 'value',
                // max: option.xAxis[0].data.length * 100,
                show: false
            }
            myChart.setOption(option, true);
        },
        drawPie2(option) {
            let myChart = this.$echarts.init(document.getElementById("myChart2"));
            // 增加了一个隐藏的x轴，用来控制线图的点的位置
            option.xAxis[1] = {
                type: 'value',
                // max: option.xAxis[0].data.length * 100,
                show: false
            }
            myChart.setOption(option, true);
        },
        drawPie3(option) {
            // 基于准备好的dom，初始化echarts实例
            let chart = this.$echarts.init(document.getElementById('myChart3'))
            // 绘制图表
            chart.setOption(option, true)
        },
        drawPie4(option) {
            // 基于准备好的dom，初始化echarts实例
            let chart = this.$echarts.init(document.getElementById('myChart4'))
            // 绘制图表
            chart.setOption(option, true)
        },
        drawPie5() {
            let myChart5 = this.$echarts.init(document.getElementById("myChart5"));
            myChart5.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} {c} ({d}%)",
                    textStyle: {
                        fontSize: 14
                    }
                },
                legend: {
                    bottom: '-10%',
                    icon: "rect",
                    itemGap: 5,
                    itemHeight: 12, // 图例icon高度
                    itemWidth: 12, // 图例icon宽度
                    padding: [25, 0],
                    textStyle: {
                        fontSize: 10
                    },
                },
                series: [
                    {
                        type: "pie",
                        radius: ["70%", "50%"],
                        data: [
                            { value: 1048, name: 'Search Engine' },
                            { value: 735, name: 'Direct' },
                            { value: 580, name: 'Email' },
                            { value: 484, name: 'Union Ads' },
                            { value: 300, name: 'Video Ads' }
                        ],
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68',],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },

                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart5.resize();
        },
        drawPie6() {
            let myChart6 = this.$echarts.init(document.getElementById("myChart6"));
            myChart6.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{b} {c} ({d}%)",
                    textStyle: {
                        fontSize: 14
                    }
                },
                legend: {
                    bottom: '-10%',
                    icon: "rect",
                    itemGap: 5,
                    itemHeight: 12, // 图例icon高度
                    itemWidth: 12, // 图例icon宽度
                    padding: [25, 0],
                    textStyle: {
                        fontSize: 10
                    },
                },
                series: [
                    {
                        type: "pie",
                        radius: ["70%", "50%"],
                        data: [
                            { value: 1048, name: 'Search Engine' },
                            { value: 735, name: 'Direct' },
                            { value: 580, name: 'Email' },
                            { value: 484, name: 'Union Ads' },
                            { value: 300, name: 'Video Ads' }
                        ],
                        color: ['#DDB2F9', '#F89589', '#2CD4D3', '#9577e5', '#FEC776', '#FC6780', '#7892EC', '#B28C68',],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },

                        center: ['50%', '50%'],
                    },

                ],
            });
            myChart6.resize();
        },

        changeTabtype(e) {
            if (e == '1') {
                this.startDate1 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
                this.queryAmountCountChartmap()
            } else if (e == '2') {
                this.startDate1 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
                this.queryAmountCountChartmap()
            } else if (e == '3') {
                this.startDate1 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
                this.queryAmountCountChartmap()
            } else if (e == '4') {
                this.startDate1 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
                this.queryAmountCountChartmap()
            }
        },
        changeTabtype2(e) {
            if (e == '1') {
                this.startDate2 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
                this.queryDoubleReport()
            } else if (e == '2') {
                this.startDate2 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
                this.queryDoubleReport()
            } else if (e == '3') {
                this.startDate2 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
                this.queryDoubleReport()
            } else if (e == '4') {
                this.startDate2 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
                this.queryDoubleReport()
            }
        },
        changeTabtype3(e) {
            if (e == '1') {
                this.startDate3 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
                this.queryRepeatAmountRatemap()
            } else if (e == '2') {
                this.startDate3 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
                this.queryRepeatAmountRatemap()
            } else if (e == '3') {
                this.startDate3 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
                this.queryRepeatAmountRatemap()
            } else if (e == '4') {
                this.startDate3 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
                this.queryRepeatAmountRatemap()
            }
        },
        changeTabtype4(e) {
            if (e == '1') {
                this.startDate4 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
                this.queryRepeatOrderRatemap()
            } else if (e == '2') {
                this.startDate4 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
                this.queryRepeatOrderRatemap()
            } else if (e == '3') {
                this.startDate4 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
                this.queryRepeatOrderRatemap()
            } else if (e == '4') {
                this.startDate4 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
                this.queryRepeatOrderRatemap()
            }
        },
        changeTabtype5(e) {
            if (e == '1') {
                this.startDate5 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
                this.queryTop5Amountmap()
                this.queryAffliateAmountRatemap()
            } else if (e == '2') {
                this.startDate5 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
                this.queryTop5Amountmap()
                this.queryAffliateAmountRatemap()
            } else if (e == '3') {
                this.startDate5 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
                this.queryTop5Amountmap()
                this.queryAffliateAmountRatemap()
            } else if (e == '4') {
                this.startDate5 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
                this.queryTop5Amountmap()
                this.queryAffliateAmountRatemap()
            }
        },
        changeTabtype6(e) {
            if (e == '1') {
                this.startDate6 = this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
                this.queryAffliateCountRatemap()
                this.queryTop5Countmap()
            } else if (e == '2') {
                this.startDate6 = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
                this.queryAffliateCountRatemap()
                this.queryTop5Countmap()
            } else if (e == '3') {
                this.startDate6 = this.$moment().subtract(90, 'days').format('YYYY-MM-DD')
                this.queryAffliateCountRatemap()
                this.queryTop5Countmap()
            } else if (e == '4') {
                this.startDate6 = this.$moment().subtract(365, 'days').format('YYYY-MM-DD')
                this.queryAffliateCountRatemap()
                this.queryTop5Countmap()
            }
        }

    }
}
</script>
<style lang="less" scoped>
.bulletinBoard {
    height: 100%;
    overflow-y: scroll;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px;

    background-color: #fff;

    .title {
        font-weight: 600;
    }

    #myChart1 {
        height: 300px;
    }

    #myChart2 {
        height: 300px;
    }

    #myChart3 {
        height: 300px;
    }

    #myChart4 {
        height: 300px;
    }
}
</style>